module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_VB.9a41945c.jpg";